<div class="backgroundimg">
  <div class="container">
    <div class="product-steps">
      <div class="product-steps-header">
        <h1 class="product-steps-header-title">
          {{ stepTitle }}
        </h1>
        <p class="product-steps-header-text">
          {{ stepMessage }}
        </p>
      </div>
      <div class="product-steps-description">
        @for (step of steps; track step) {
          <div class="product-steps-description-section">
            <img class="product-steps-description-section-icon" src="{{ imageBasePath + step?.imgURL }}" alt="">
            <h4 class="product-steps-description-section-title"> {{ step?.title }} </h4>
            <p class="product-steps-description-section-text"> {{ step?.text }} </p>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="mobileimg">

</div>
<div class="colorstrip">
  <div class="container">
    <div class="colorstrip-stpes">
      <p class="colorstrip-text">Need to protect your business? We’ve got you covered.</p>
      <button
        class="btn colorstrip-btn"
        (click) = "navigate('/get-a-quote','Get a quote')"
        >
        Get a quote
      </button>
    </div>
  </div>
</div>
